export const getStatus = (status: string) => {
  switch (status) {
    case 'initial':
      return (
        <p className="px-4 py-2 text-orange-300 bg-orange-100 font-semibold text-xs md:text-sm rounded-md">
          Procesando
        </p>
      );
    case 'confirmed':
      return (
        <p className="px-4 py-2 text-success-300 bg-success-100 font-semibold text-xs md:text-sm rounded-md">
          Listo para pick up
        </p>
      );
    case 'complete':
      return (
        <p className="px-4 py-2 text-color-primary-text-300 bg-color-primary-50 font-semibold text-xs md:text-sm rounded-md">
          Finalizado
        </p>
      );
    case 'cancelled':
      return (
        <p className="px-4 py-2 text-error-300 bg-error-100 font-semibold text-xs md:text-sm rounded-md">
          Cancelada
        </p>
      );
    default:
  }
};
